module.exports = __webpack_public_path__ + "static/media/Nueva.80762dc3.svg";